export const MAX_MERCHANDISING_REGEX_LENGTH = 200;

const unsupportedRe2Feature = (pattern) => {
  let escaped = false;
  let inCharacterClass = false;

  for (let index = 0; index < pattern.length; index += 1) {
    const character = pattern[index];

    if (escaped) {
      if (!inCharacterClass && (/[1-9]/.test(character)
        || (character === 'k' && pattern[index + 1] === '<'))) return true;
      escaped = false;
      continue;
    }

    if (character === '\\') {
      escaped = true;
      continue;
    }
    if (character === '[' && !inCharacterClass) {
      inCharacterClass = true;
      continue;
    }
    if (character === ']' && inCharacterClass) {
      inCharacterClass = false;
      continue;
    }
    if (inCharacterClass || character !== '(' || pattern[index + 1] !== '?') continue;

    const prefix = pattern.slice(index, index + 4);
    if (prefix.startsWith('(?=') || prefix.startsWith('(?!')
      || prefix.startsWith('(?<=') || prefix.startsWith('(?<!')
      || prefix.startsWith('(?>')) return true;
  }
  return false;
};

/**
 * The search service evaluates merchandising patterns with RE2. Validate the
 * JavaScript-compatible RE2 subset in the editor and reject the two constructs
 * most often accepted by browsers but rejected by RE2: lookarounds and
 * backreferences. The service remains the authoritative validator.
 */
export const merchandisingRegexError = (value) => {
  if (typeof value !== 'string' || !value.length) return null;
  if (value.length > MAX_MERCHANDISING_REGEX_LENGTH) return 'tooLong';
  if (unsupportedRe2Feature(value)) return 'unsupported';
  try {
    // eslint-disable-next-line no-new
    new RegExp(value, 'iu');
    return null;
  } catch (_error) {
    return 'invalid';
  }
};

export default merchandisingRegexError;
